var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Button } from '@trustpilot/businessapp-patternlibrary';
import { Link, Input } from '../CommonUI/Controls';
import { Auth } from '../Auth';
import { Flex, Box } from '../CommonUI/Layout';
import { Text, LocalizationProvider } from 'ilenia';
import { StyleSheet, css } from 'aphrodite';
import { SIGNUP_EMAIL_KEY } from '../Model';
import translations from '../localization/en-US/string.json';
import { Link as NavLink } from 'react-router-dom';
import * as commonStyles from '../Styles/common';
import * as flat from 'flat';
import '../Styles/login.css';
var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
var Login = (function (_super) {
    __extends(Login, _super);
    function Login(props) {
        var _this = _super.call(this, props) || this;
        _this.withLinkTracking = function (track, func) {
            return function (event) {
                if (_this.props.trackLink) {
                    _this.props.trackLink(track);
                }
                if (func) {
                    func(event);
                }
            };
        };
        _this.withButtonTracking = function (track, func) {
            return function (event) {
                if (_this.props.trackButton) {
                    _this.props.trackButton(track);
                }
                if (func) {
                    func(event);
                }
            };
        };
        _this.state = { email: '', password: '', emailValid: true, passwordValid: true };
        _this.onChange = _this.onChange.bind(_this);
        _this.onLogin = _this.onLogin.bind(_this);
        _this.validateEmail = _this.validateEmail.bind(_this);
        _this.validatePassword = _this.validatePassword.bind(_this);
        _this.withLinkTracking = _this.withLinkTracking.bind(_this);
        _this.withButtonTracking = _this.withButtonTracking.bind(_this);
        return _this;
    }
    Login.prototype.componentDidMount = function () {
        var email = this.state.email;
        if (!email) {
            var signupEmail = '';
            try {
                signupEmail = localStorage.getItem(SIGNUP_EMAIL_KEY);
            }
            catch (e) { }
            if (signupEmail) {
                this.setState({ email: signupEmail });
            }
        }
    };
    Login.prototype.onChange = function (field) {
        var _this = this;
        return function (event) {
            var newState = {};
            newState[field] = event.target.value;
            _this.setState(newState);
        };
    };
    Login.prototype.onLogin = function (e) {
        var _this = this;
        e.preventDefault();
        var emailValid = emailPattern.test(this.state.email);
        var passwordValid = this.state.password ? true : false;
        var _a = this.props, cookiesDomain = _a.cookiesDomain, authenticationApiUrl = _a.authenticationApiUrl;
        if (emailValid && passwordValid) {
            Auth.login(this.state.email, this.state.password, cookiesDomain, authenticationApiUrl).then(function (_a) {
                var loggedIn = _a.loggedIn, mfaRequired = _a.mfaRequired, mfaPendingCredential = _a.mfaPendingCredential, mfaEnrollmentId = _a.mfaEnrollmentId, phoneNumber = _a.phoneNumber;
                var _b = _this.props, onMfaRequired = _b.onMfaRequired, onLoggedIn = _b.onLoggedIn;
                if (mfaRequired) {
                    if (onMfaRequired) {
                        onMfaRequired(mfaRequired, mfaPendingCredential, mfaEnrollmentId, phoneNumber);
                    }
                }
                else if (onLoggedIn) {
                    onLoggedIn(loggedIn);
                }
            });
        }
        this.setState({ emailValid: emailValid, passwordValid: passwordValid });
    };
    Login.prototype.validateEmail = function (value) {
        return this.state.emailValid;
    };
    Login.prototype.validatePassword = function (value) {
        return this.state.passwordValid;
    };
    Login.prototype.render = function () {
        var _this = this;
        var _a = this.props, source = _a.source, locale = _a.locale, forgotPasswordUrl = _a.forgotPasswordUrl, createAccountUrl = _a.createAccountUrl;
        var lowered = source.toLowerCase();
        var utmParams = "utm_source=" + lowered + "&utm_medium=appstore&utm_campaign=" + lowered + "app";
        return (React.createElement(Box, { pt: '16px', className: "trustpilot_form" },
            React.createElement(LocalizationProvider, { locale: locale, translations: flat.flatten(translations) },
                React.createElement(Box, { className: css(styles.layout) },
                    React.createElement("form", { onSubmit: this.onLogin },
                        React.createElement(Flex, null,
                            React.createElement("h1", null,
                                React.createElement(Text, { id: "login.title" })),
                            React.createElement(Box, { className: css(styles.trustpilotInput) },
                                React.createElement(Box, { pb: '14px' },
                                    React.createElement(Input, { id: "email", label: React.createElement(Text, { id: "login.email" }), onChange: this.onChange('email'), value: this.state.email, errorMessage: this.validateEmail(this.state.email)
                                            ? undefined
                                            : React.createElement(Text, { id: "login.validationError" }) })),
                                React.createElement(Box, { pb: '22px' },
                                    React.createElement(Input, { id: 'password', label: React.createElement(Text, { id: "login.password" }), onChange: this.onChange('password'), value: this.state.password, errorMessage: this.validatePassword(this.state.password)
                                            ? undefined
                                            : React.createElement(Text, { id: "login.validationPassword" }), type: "password" })),
                                React.createElement(Box, { pb: '12px' },
                                    React.createElement(Button, { id: "login", onClick: this.withButtonTracking({
                                            placement: 'Bottom left corner',
                                            action: 'Login to business app',
                                            name: 'login-to-business-app-button',
                                            source: source,
                                        }, this.onLogin), className: css(styles.button) },
                                        React.createElement(Text, { id: "login.button" }))),
                                React.createElement(Box, null,
                                    React.createElement(Link, { onClick: this.withLinkTracking({
                                            placement: 'Above login button',
                                            target: 'Forgot password business app page',
                                            name: 'forgot-password-link',
                                            source: source,
                                        }), href: forgotPasswordUrl, target: "_blank" },
                                        React.createElement(Text, { id: "login.forgotPassword" }))),
                                React.createElement(Box, { pb: '22px' }, createAccountUrl
                                    ? (React.createElement(Link, { className: css(styles.link), onClick: this.withLinkTracking({
                                            placement: 'Above login button',
                                            target: 'Signup business app page',
                                            name: 'signup-link',
                                            source: source,
                                        }), href: createAccountUrl + "?" + utmParams, target: "_blank" },
                                        React.createElement(Text, { id: "login.createAccount" }))) : (React.createElement(NavLink, { to: '/signup', className: css(styles.navLink), onClick: function () {
                                        _this.props.trackLink({
                                            placement: 'Above login button',
                                            target: 'Signup business app page',
                                            name: 'signup-link',
                                            source: source,
                                        });
                                    } },
                                    React.createElement(Text, { id: "login.createAccount" })))))))))));
    };
    return Login;
}(React.Component));
export { Login };
var styles = StyleSheet.create({
    layout: {
        fontFamily: '\'TrustpilotDefaultFont\', Arial, sans-serif',
    },
    link: {
        display: 'block'
    },
    button: __assign({ width: '100%' }, commonStyles.button),
    navLink: {
        fontSize: '14px',
        lineHeight: '20px',
        textAlign: 'left',
        textDecoration: 'none',
        border: '2px solid transparent',
        borderRadius: '2px',
        outline: 'none',
        color: '#368CD7'
    },
    trustpilotInput: {
        width: '400px'
    },
});
